import request from '@/utils/request';

export function getBase(mavinEid) {
    return request({
        url: `/position/mavin/base/${mavinEid}`,
        method: 'get'
    });
}

export function updateBase(data) {
    return request({
        url: `/position/mavin/base`,
        method: 'post',
        data: data
    });
}

export function getReview(mavinEid) {
    return request({
        url: `/position/mavin/base/review/${mavinEid}`,
        method: 'get'
    })
}